<template>

  <div class="row my-2 card mx-1 py-3" :class="finished == '1'
      ? 'border-danger bg-danger text-white'
      : import_attempts == 0 ? 'text-secondary bg-light' : 'border-success'">

    <i v-if="!loading" class="icon-refresh cursor-pointer ml-4" @click="refresh()"></i>
    <div class="col-12">
      <div v-if="success || import_attempts > 0" class="ml-2 rounded-2 border-light border-1 p-2 float-right"
        :class="getColorScore()">
        <i class="icon-search text-white mr-1"></i>
        <span v-if="success" class="text-white">{{ success }}</span>
        <span v-else class="text-white">0.00</span>
      </div>
      <Tooltip :text="$t('lang.label.avg_emails_tomorrow')" class="rounded-2 border-light border-1 p-2 float-right ml-1" :class="getTomorrowEmailScore()">
        <div v-if="targetresult.avg_tomorrow_new_emails" >
          <i class="icon-arrow-right text-white mr-1"></i>
          <span class="text-white">{{ targetresult.avg_tomorrow_new_emails }}</span>
        </div>
      </Tooltip>
      <Tooltip :text="$t('lang.label.avg_emails_today')" class="rounded-2 border-light border-1 p-2 float-right ml-0 mr-1" :class="getTodayEmailScore()">
        <div v-if="targetresult.avg_today_new_emails">
          <i class="icon-paper-plane text-white mr-1"></i>
          <span class="text-white">{{ targetresult.avg_today_new_emails }}</span>
        </div>
      </Tooltip>
      <Tooltip :text="$t('lang.label.avg_emails_last_3_days')" class="rounded-2 border-light border-1 p-2 float-right ml-0 mr-2" :class="getEmailScore()">
        <div v-if="targetresult.avg_emails">
          <i class="icon-arrow-left text-white mr-1"></i>
          <span class="text-white">{{ targetresult.avg_emails }}</span>
        </div>
      </Tooltip>
      <div v-if="newtarget" class="rounded-2 p-2 float-right bg-primary">
        <span class="text-white">New</span>
      </div>
      <div class="row">
        <div class="col-6" v-if="(!finished || typelist == 9)">
          <SearchPriorityCampaign :target_id="listtarget[0].target_id" :typelist="typelist"></SearchPriorityCampaign>
        </div>
        <div class="col-12">
          <small v-if="finished == '1'" class="text-white">
            <i class="icon-warning"></i>
            Target finished = import rate &le; 0.02
            <!-- Target finished = ( > 80% prospects allready contacted) + ( > 80% imported) -->
          </small>
          <h6 class="mb-2 mt-3">
            <a :href="'/orders/' + listtarget[0].target_id" target="_blank" class="text-primary">
              {{ listtarget[0].target_name }} (id:
              {{ listtarget[0].target_id }})
            </a>
          </h6>
        </div>
      </div>
      <div class="row card m-1 py-1 text-secondary">
        <div v-if="import_attempts" class="col-12">
          <small class="bold"><strong>Last import:</strong> {{ targetresult.last_attempt }}</small>
        </div>
        <div v-if="import_attempts" class="col-12 text-left">
          <small>
            <strong>Last 24 hs: </strong>
            <span class="text-primary">{{ import_attempts }} import attempts </span>
          </small>
          <small class="text-primary" v-if="import_attempts > 0">, {{ targetresult.import_success }} <i
              class="icon-user-plus "></i> imported</small>
          <small class="text-success" v-if="import_attempts > 0"> ({{ targetresult.import_new }} <i
              class="icon-user-plus "></i> new)</small>
        </div>


      </div>


    </div>

    <div class="col-12">
      <loading-spinner v-if="!loadOwarmStats">

      </loading-spinner>
      <div class="row" :key="keygraph" v-else>
        <div class="col-6" v-if="loadOwarmStats">
          <doughnut-chart class="p-4" :chart-data="chartDataApollo" :options="chartDataApollo.options" />
        </div>

        <div class="col-6" v-if="loadOwarmStats">
          <doughnut-chart class="p-4" :chart-data="chartData" :options="chartData.options" />
        </div>
      </div>
    </div>

    <!--
              <div class="col-md-12 ">
                <strong
                  >Apollo target total:
                  {{ parseInt(listtarget[0].apollo_total_contacts) }}
                </strong>
                <br>
                <div
                  class="progress border bg-secondary"
                  :style="'height: 137px'">
                  <div
                    class="progress-bar pt-2  bg-secondary"
                    role="progressbar"
                    :style="'width: 100%;margin-top: -7px;'"
                  >
                 
                      <div class="row px-2">
                      <ProgressBar 
                       v-if="!loading" 
                       :color="'bg-primary'"
                       :title="'Imported Apollo'" 
                       :quantity="targetresult.imported" 
                       :total="listtarget[0].apollo_total_contacts"
                       :percentage="100"
                       ></ProgressBar>
                      </div>
                      <div class="row px-2">
                      <ProgressBar 
                       v-if="!loading" 
                       :color="'bg-primary'"
                       :title="'Imported Oliver'" 
                       :quantity="targetresult.imported_outside" 
                       :total="listtarget[0].apollo_total_contacts"></ProgressBar>
                      </div>

                      <div class="row px-2">
                      <ProgressBar 
                       v-if="!loading" 
                       :color="'bg-primary'"
                       :title="'Not enriched'" 
                       :quantity="targetresult.not_enriched" 
                       :total="imported"></ProgressBar>
                      </div>
                      <div class="row px-2">
                        <ProgressBar 
                         v-if="!loading" 
                         :color="'bg-primary'"
                         :title="'Email not found'" 
                         :quantity="targetresult.email_not_found" 
                         :total="imported"></ProgressBar>
                      </div>

                      <div class="row px-2">
                       <ProgressBar 
                       :title="'Already contacted'" 
                       v-if="!loading" 
                       :quantity="targetresult.used_target" 
                       :total="listtarget[0].apollo_total_contacts"></ProgressBar>
                      </div>


                    <span v-if="loading"  class="loadingres mr-1 ml-1 spinner-border loading-spinner text-white"></span>
                   
                  


                    <div class="row  px-2" v-if="!loading">
                      <ProgressBar 
                       v-if="targetresult.totalnotused > 0" 
                       :color="'bg-danger'"
                       :title="'Impossible'" 
                       :quantity="targetresult.totalnotused" 
                       :total="parseInt(targetresult.imported)"></ProgressBar>
                    </div>
                     
                  </div>
                </div>
                <small
                  class="text-primary  text-black"
                  v-if="quantity > 0"
                >
                  <i class="icon-download"></i> Contacts obtained in Target last
                  10 minutes: {{ quantity }} at:
                  {{ created }}<br />
                </small>
                <small
                  class="text-primary  text-black"
                  v-if="imported >
                    parseInt(listtarget[0].apollo_actual_page) * 100
                  "
                >
                  <i class="icon-warning"></i> if there are more contacts
                  imported than total target, it is because someone did changes in the target so now the total contacts is less than before.
                </small>
              </div> -->


    <div class="row text-black border m-2">

      <div class="col-12 p-2">
        <button v-if="targetresult.totalnotused > 0" class="btn btn-sm btn-primary" :disabled="loadingcalc"
          @click="calculatedetails()"><small>Re-calculate contact details</small></button>
        <button v-else class="btn btn-sm btn-primary" @click="calculatedetails()" :disabled="loadingcalc">Calculate
          contact details</button>
        <span v-if="loadingcalc" class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"></span>
        <small v-if="loadingcalc">Calculating...It could take some minutes...</small>
        <div v-if="targetresult.totalnotused > 0">
          <strong><small><b>Total Impossible to contact: {{ targetresult.totalnotused }}</b></small></strong>
        </div>

        <table class="table-sm table-bordered mt-2" v-if="targetresult.totalnotused > 0">
          <thead>
            <th>
              Status
            </th>
            <th>
              Total
            </th>
            <th>
              Prcnt
            </th>
          </thead>
          <tbody>
            <template v-for="item in forbidden_status">
              <tr v-if="targetresult[item.key]" :key="item.key">
                <td>
                  <small>{{ item.label }}</small>
                </td>
                <td><small>{{ targetresult[item.key] }} </small></td>
                <td><small>{{ getPercentageAvailable(targetresult[item.key], targetresult.totalnotused) }} %</small></td>
              </tr>
            </template>
            <template v-if="targetresult.notvalidstatus">
              <tr v-for="(count, status) in targetresult.notvalidstatus_by_status" :key="status">
                <td>
                  <small>{{ status }} (global)</small>
                </td>
                <td>
                  <small>{{ count }}</small>
                </td>
                <td>
                  <small>{{ getPercentageAvailable(count, targetresult.totalnotused) }} %</small>
                </td>
              </tr>
            </template>

          </tbody>
        </table>

        <small class="badge badge-secondary">{{ targetresult.last_update }}</small>
      </div>
    </div>
    <div class="col-12 mt-3" v-if="!opencampaign" @click="opencampaign = true">
      <button class="btn btn-sm btn-primary" :disabled="loading">Campaigns Info</button>
    </div>
    <div class="col-12 text-black" v-if="opencampaign">
      <div class="row px-3">

        <li v-for="item in filteredListTarget" :key="item.campaigns"
          class="float-left text-center text-secondary card p-2 col-md-6">
          <span v-if="typelist == 1 || typelist == 2">
            <i @click="select(item.campaigns)" v-if="!getSelected(item.campaigns)" class="
                          icon-circle
                          border
                          text-white
                          float-left
                          cursor-pointer
                        "></i>
            <i @click="unselect(item.campaigns)" v-if="getSelected(item.campaigns)" class="
                          icon-checkmark
                          border
                          text-primary
                          float-left
                          cursor-pointer
                        "></i>
          </span>
          <small class="text-secondary">{{ item.name }} ({{ item.campaigns }})</small>

          <small class="text-secondary bg-white border mt-2">
            <small class="d-block">Api: {{ item.api }}</small>
            <small class="d-block">Calls: {{ item.calls }}</small>
            <small class="d-block">Contacts last 10 min: {{ quantity }}</small>
            <small class="d-block">Last call: {{ item.updated }}</small>
          </small>
          <small class="mt-4">Emails sent (Emails per day:
            {{ item.emails_per_day }})</small>

          <small>Available contacts
            <i @click="calculateAvailable(item.campaigns)" class="
                          p-1
                          rounded-circle
                          bg-primary
                          text-white
                          icon-refresh
                          cursor-pointer
                        "></i></small>
          <div class="progress mb-4 border bg-secondary" style="height: 15px">
            <div class="progress-bar bg-primary pl-2" role="progressbar" :style="'width:' +
              getPercentageAvailable(item.available_contacts, 100) +
              '%;'
              ">
              <small>{{ item.available_contacts }} ({{
                getPercentageAvailable(
                item.available_contacts,
                100
                )
                }}%)</small>
            </div>
          </div>
          <div v-if="item.in_queue == 1" class="badge badge-primary">In queue</div>

          <small class="text-white text-left" v-if="item.emails_per_day == 0">
            <i class="icon-warning"></i>
            Emails per day = 0.
          </small>
        </li>
      </div>
    </div>

    <!-- Nuevos gráficos de teléfonos - Sección separada -->
    <div class="col-12 mt-4">
      <loading-spinner v-if="!loadPhoneStats"></loading-spinner>
      <div class="row" :key="keygraph" v-else>
        <div class="col-6" v-if="loadPhoneStats">
          <doughnut-chart class="p-4" :chart-data="chartDataPhone" :options="chartDataPhone.options" />
        </div>
        <div class="col-6" v-if="loadPhoneStats">
          <doughnut-chart class="p-4" :chart-data="chartDataColdCall" :options="chartDataColdCall.options" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingOliver from "@/components/LoadingOliver.vue";
import SearchPriorityCampaign from "@/components/SearchSituation/SearchPriorityCampaign.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import ProgressBar from "@/components/Common/ProgressBar.vue";
import DoughnutChart from "@/components/DoughnutChart.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import { campaignsService, targetsService, monitorService } from "@/_services";
import LoadingSpinner from '../LoadingSpinner.vue';



export default {
  data() {
    return {
      forbidden_status: [
        {
          key: 'blacklist',
          label: 'Blacklist (client + global)',
        },
        {
          key: 'oliveroff',
          label: 'Oliver Off (campaign)',
        },
        {
          key: 'oliveroff6month',
          label: 'Opp tags: not scope or valid event (client)',
        },
        {
          key: 'oppnotscope',
          label: 'Opp tag not scope (client)',
        },
        {
          key: 'alreadyhasevent',
          label: 'Already has event (client)',
        },
        {
          key: 'donotcontact',
          label: 'Do not contact (client)',
        },
        {
          key: 'contactedtoday',
          label: 'Contacted today (global)',
        },
        {
          key: 'businessalreadycontacted',
          label: 'Business already contacted (client)',
        },
      ],
      keygraph: 1,
      contactUsed: [],
      opencampaign: false,
      loadingcalc: false,
      imported: 0,
      quantity: 0,
      percentage_used: 0,
      not_enriched: 0,
      created: '',
      targetresult: false,
      loading: true,
      finished: 0,
      success: 0,
      import_attempts: 0,
      newtarget: false,
      loadOwarmStats: false,
      loadPhoneStats: false,
      phoneData: null,
      chartDataPhone: {
        labels: [
          "Valid phone",
          "Unavailable phone",
          "Pending phone research",
        ],
        datasets: [
          {
            backgroundColor: [
              "#5A9BD5", // Azul claro elegante
              "#A5A5A5", // Gris claro elegante
              "#ED7D31", // Naranja suave
            ],
            data: ["0", "0", "0"],
          },
        ],
        options: {
          cutoutPercentage: 30,
          responsive: true,
          aspectRatio: 1,
          maintainAspectRatio: false,
          devicePixelRatio: 2,
          title: {
            display: true,
            text: "Engaged contacts: ",
            innerText: "contacts",
          },
          legend: {
            display: true,
            position: 'right',
          },
        },
      },
      chartDataColdCall: {
        labels: [
          "Generated cold call task",
          "Pending cold call task generation",
        ],
        datasets: [
          {
            backgroundColor: [
              "#ED7D31", // Naranja suave
              "#5A9BD5", // Azul claro elegante
            ],
            data: ["0", "0"],
          },
        ],
        options: {
          cutoutPercentage: 30,
          responsive: true,
          aspectRatio: 1,
          maintainAspectRatio: false,
          devicePixelRatio: 2,
          title: {
            display: true,
            text: "Valid phones: ",
            innerText: "phones",
          },
          legend: {
            display: true,
            position: 'right',
          },
        },
      },
      chartDataApollo: {
        labels: [
          "Remaining contacts (Apollo)",
          "Imported contacts (Apollo)",
        ],
        datasets: [
          {
            backgroundColor: [
              "#ED7D31", // Naranja suave y diferenciado
              "#5A9BD5", // Azul claro elegante
            ],
            data: ["40", "60"],
          },
        ],
        options: {
          cutoutPercentage: 30,
          responsive: true,
          aspectRatio: 1,
          maintainAspectRatio: false,
          devicePixelRatio: 2,
          title: {
            display: true,
            text: "Apollo Target Total: " + parseInt(this.listtarget[0].apollo_total_contacts),
            innerText: "emails",
          },
          legend: {
            display: true,
            position: 'right',
          },
        },
      },
      chartData: {
        labels: [
          "Engaged contacts",
          "Ready to use contacts",
          "Waiting to be enriched contacts",
          "Forbidden contacts",
        ],
        datasets: [
          {
            backgroundColor: [
              "#5A9BD5", // Azul claro elegante
              "#2ACC80", // Verde
              "#A5A5A5", // Gris claro elegante
              "#FF0000", // Rojo
            ],
            data: ["10", "10", "20", "30"],
          },
        ],
        options: {
          cutoutPercentage: 30,
          responsive: true,
          aspectRatio: 1,
          maintainAspectRatio: false,
          devicePixelRatio: 2,
          title: {
            display: true,
            text: "Import contacts: ",
            innerText: "emails",
          },
          legend: {
            display: true,
            position: 'right',
          },
        },
      },
    }
  },
  props: {
    listtarget: false,
    selected: false,
    typelist: false,
    countselected: false
  },
  components: {
    LoadingOliver,
    SearchPriorityCampaign,
    Fieldset,
    ProgressBar,
    DoughnutChart,
    LoadingSpinner,
    Tooltip,
  },
  computed: {
    filteredListTarget() {
      return this.listtarget.filter(item =>
        this.getSelected(item.campaigns) ||
        this.countselected == 0 ||
        this.typelist != 2
      );
    }
  },
  created() {
    this.refresh()
    this.loadPhoneData()
  },
  methods: {
    refresh() {
      this.loading = true
      this.loadPhoneStats = false
      if (this.listtarget[0].apollo_actual_page == null) {
        this.listtarget[0].apollo_actual_page = 0
      }

      targetsService.getTargetApolloDetails(this.listtarget[0].target_id).then((result) => {
        if (result[0] != undefined) {
          this.imported = result[0].imported
          this.quantity = result[0].quantity
          this.percentage_used = result[0].percentage_used
          this.not_enriched = result[0].not_enriched
          this.created = result[0].created
          this.finished = result[0].finished
          this.success = result[0].success
          this.import_attempts = result[0].import_attempts
          this.targetresult = result[0]

          // Ready to use = (imported contacts - engaged contacts) - Forbiden  - Waiting to be enriched <-- si da negativo le pones 0
          const readyToUse = this.imported - this.targetresult.totalnotused - this.not_enriched - this.targetresult.used_target

          this.chartDataApollo.datasets[0].data = [this.listtarget[0].apollo_total_contacts - this.imported, this.imported]

          this.chartData.options.title.text = "Imported contacts: " + this.imported // ( this.targetresult.used_target > this.imported) ?  "Imported contacts: "  + this.targetresult.used_target :  "Imported contacts: "  + this.imported 

          this.chartData.datasets[0].data = [this.targetresult.used_target, (readyToUse > 0) ? readyToUse : 0, this.targetresult.not_enriched, this.targetresult.totalnotused]

          this.loadOwarmStats = true;
          this.keygraph++;
        } else {
          this.newtarget = true
        }
        this.loading = false
        // Recargar datos de teléfonos después de cargar los datos principales
        this.loadPhoneData()
      });
    },

    showitem() {
      /*if(this.typelist == 12 && this.finished == '1' && this.success == 0){
        return false
      }
      if(this.typelist == 10 && this.finished == '1' && this.success == 0){
        return false
      }
      if(this.typelist == 11 && this.success > 0){
        return false
      }*/
      return true
    },
    loadPhoneData() {
      targetsService.getDataPhoneByTarget(this.listtarget[0].target_id).then((result) => {
        if (result.result) {
          this.phoneData = result.result;

          // Actualizar primer gráfico (Engaged contacts)
          this.chartDataPhone.options.title.text = "Engaged contacts: " + this.phoneData.total_contacts;
          this.chartDataPhone.datasets[0].data = [
            this.phoneData.valid_phone,
            this.phoneData.unavailable_phone,
            this.phoneData.pending_phone_research
          ];

          // Actualizar segundo gráfico (Valid phones)
          this.chartDataColdCall.options.title.text = "Valid phones: " + this.phoneData.valid_phone;
          this.chartDataColdCall.datasets[0].data = [
            this.phoneData.generated_cold_call_task,
            this.phoneData.pending_cold_call_task_generation
          ];

          this.loadPhoneStats = true;
          this.keygraph++;
        }
      }).catch((error) => {
        console.error('Error loading phone data:', error);
      });
    },
    calculatedetails() {
      this.loadingcalc = true;
      targetsService.calculateDetails(this.listtarget[0].target_id).then((result) => {
        this.loadingcalc = false;
        this.refresh()
      });
    },
    getColorScore() {
      if (this.success > 0.3) {
        return "bg-success"
      }
      if (this.success > 0.1) {
        return "bg-warning"
      }
      return "bg-danger"
    },
    getEmailScore() {
      let percentage = (this.targetresult.avg_emails / this.targetresult.new_emails_per_day * 100).toFixed(2);
      if (percentage > 40) {
        return "bg-success"
      }
      if (percentage > 10) {
        return "bg-warning"
      }
      return "bg-danger"
    },
    getTodayEmailScore() {
      let percentage = (this.targetresult.avg_today_new_emails / this.targetresult.new_emails_per_day * 100).toFixed(2);
      if (percentage > 40) {
        return "bg-success"
      }
      if (percentage > 10) {
        return "bg-warning"
      }
      return "bg-danger"
    },
    getTomorrowEmailScore() {
      let percentage = (this.targetresult.avg_tomorrow_new_emails / this.targetresult.new_emails_per_day * 100).toFixed(2);
      if (percentage > 40) {
        return "bg-success"
      }
      if (percentage > 10) {
        return "bg-warning"
      }
      return "bg-danger"
    },
    getSelected(campaign_id) {
      return this.selected[campaign_id];
    },
    getPercentageAvailable(available, total) {
      if (available == null) {
        available = 0;
      }
      if (total == null) {
        total = 0;
      }
      if (available == 0 && total == 0) {
        return 0;
      }
      return Math.round((available * 100) / total);
    },

    getPercentage(target) {
      let total = 0;
      if (
        parseInt(target.apollo_actual_page) * 100 >
        parseInt(target.apollo_total_contacts)
      ) {
        total = parseInt(target.apollo_total_contacts);
      } else {
        total = parseInt(target.apollo_actual_page) * 100;
      }
      if (total == 0 || target.apollo_total_contacts == null) {
        return 0;
      }
      let totalper = Math.round((total * 100) / parseInt(target.apollo_total_contacts));
      if (totalper > 100) {
        return 100
      }
      return totalper
    },
    getPercentageImported(target) {
      let total = 0;

      if (target == undefined) {
        return 0;
      }

      if (
        parseInt(target.apollo_actual_page) * 100 >
        parseInt(target.apollo_total_contacts)
      ) {
        total = parseInt(target.apollo_total_contacts);
      } else {
        total = parseInt(target.apollo_actual_page) * 100;
      }
      if (total == 0 || this.imported == null) {
        return 0;
      }
      let totalper = Math.round((parseInt(this.imported) * 100) / total);
      if (totalper > 100) {
        return 100
      }
      return totalper
    },

    getColor(target) {

      if (this.import_attempts == 0) {
        return "bg-secondary";
      }

      if (this.getPercentage(target) == 0) {
        return "bg-secondary";
      }
      if (this.getPercentage(target) > 90) {
        return "bg-danger";
      }
      if (this.getPercentage(target) > 60) {
        return "bg-warning";
      }
      return "bg-success";
    },
  },

};
</script>